import { redirect, Route, Routes, useNavigate } from "react-router-dom"
import { HomePage } from "./pages/Home"
import { LayoutNotAuth } from "./common/Layout/LayoutNoAuth"
import { LayoutAuth } from "./common/Layout/LayoutAuth"
import { ModuloPage } from "./pages/Modulos"
import { SolicitudesAyudantiasDelegado } from "./components/Ayudantias/SolicitudesAyudantiasDelegado"
import { AprobarSolicitudPage } from "./pages/Modulos/AprobarSolicitudPage"
import { ProyectosPage } from "./components/Proyectos/ProyectosAyudantias"
import { AyudantiasInvestigacion } from "./components/Proyectos/AyudantiasInvestigacion"
import { HistorialAyudantiasPage } from "./pages/Modulos/HistorialAyudantiasPage"
import { SesionExpiraPage } from "./pages/Modulos/sesionExpiraPage"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "./redux/store"
import { useEffect, useState } from "react"
import { useAppSelector } from "./redux/hooks"
import { outUser } from "./redux/slices/auth.slice"
import { experimentalStyled } from "@mui/material"
import { useMsal } from "@azure/msal-react"
import { SolicitudesAyudantiasDirectivo } from "./components/Ayudantias/SolicitudesAyudantiasDirectivo"
import { SolicitudesAyudantiasVicerrector } from "./components/Ayudantias/SolicitudesAyudantiasVicerrector"
import { SinAccesoPage } from "./components/Error/SinAcceso"
import { ProtectedRoute } from "./common/ProtectedRoute"
import { NotFoundPage } from "./components/Error/ErrorNotFound"
import { ReporteAyudantiaInv } from "./components/Reportes/ReporteAyudantiaInv"
import { AyudantiasAcadPage } from "./pages/Modulos/AyudantiasAcadPage"

export const AppRouter: React.FC<{}> = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const expirationTime = useSelector((state: RootState) => state.authReducer.expirationTime);
    const [isExpired, setIsExpired] = useState(expirationTime <= Date.now());

    useEffect(() => {
        
        const interval = setInterval(() => {
            let hoy = Date.now();
            if (expirationTime && expirationTime <= hoy) {
                setIsExpired(true);
                dispatch(outUser()); // Limpiar Redux
                sessionStorage.clear();
                localStorage.clear();
                window.location.href = "/sessionNull"; // Redirigir
            }
        }, 1000); // Revisa cada segundo

        //console.log(expirationTime);
        return () => clearInterval(interval);

        

    }, [expirationTime, dispatch,navigate]);
    
    return (
        <Routes>
            <Route path="/" element={<LayoutNotAuth />} >
                <Route index element={<HomePage />} />
            </Route>
            
            <Route path="/Proyectos" element={<ProtectedRoute />}>
                <Route element={<LayoutAuth />}>
                    <Route index element={<ProyectosPage />} />
                    <Route path="Ayudantias" element={<AyudantiasInvestigacion />} />
                </Route>
            </Route>

            <Route path="/Solicitudes" element={<ProtectedRoute />}>
                <Route element={<LayoutAuth />}>
                    <Route index element={<NotFoundPage />} />
                    <Route path="AyudantiasDelegado" element={<SolicitudesAyudantiasDelegado />} />
                    <Route path="AyudantiasDirectivo" element={<SolicitudesAyudantiasDirectivo />} />
                    <Route path="AyudantiasVicerrector" element={<SolicitudesAyudantiasVicerrector />}/>
                </Route>
            </Route>

            <Route path="/AyudAcad" element={<ProtectedRoute />}>
                <Route element={<LayoutAuth />}>
                    <Route index element={<AyudantiasAcadPage />} />
                </Route>
            </Route>

            <Route path="/sessionNull" element={ <SesionExpiraPage /> } />
            <Route path="/SinAcceso" element={ <SinAccesoPage /> } />

            <Route path="/Reportes" element={<ProtectedRoute />}>
                <Route element={<LayoutAuth />}>
                    <Route index element={<ReporteAyudantiaInv />} />
                </Route>
            
            </Route>

            <Route path="*" element={<LayoutNotAuth />} >
                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    )
}
